export default "__VITE_ASSET__D_W1AsxG__"